<template>
    <svg :class="['spinner', type]" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
        <circle class="path" fill="none" :stroke="stroke" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
    </svg>
</template>

<script>
export default {
    name: 'load-spinner-icon',

    props: {
      type: {
        type: String,
        default: 'white'
      },
      stroke: {
        type: String,
        default: '#ffffff'
      }
    }
}
</script>

<style lang="scss" scoped>
@import "@/module/app/theme/color.scss";

svg {
    width: 100%;
    height: 100%;
    &.primary {
      circle {
        stroke: $primary-color;
      }
    }
    &.primary-light {
      circle {
        stroke: #2874e8;
      }
    }
    &.default {
      circle {
        stroke: $white-color;
      }
    }
    &.survey {
      circle {
        stroke: $questionnaire-color;
      }
    }
}
$offset: 187;
$duration: 1.4s;

.spinner {
  animation: rotator $duration linear infinite;
}

@keyframes rotator {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(270deg); }
}

.path {
  stroke-dasharray: $offset;
  stroke-dashoffset: 0;
  transform-origin: center;
  animation:
  dash $duration ease-in-out infinite;
  // stroke: #ffffff;
}


@keyframes dash {
 0% { stroke-dashoffset: $offset; }
 50% {
   stroke-dashoffset: $offset/4;
   transform:rotate(135deg);
 }
 100% {
   stroke-dashoffset: $offset;
   transform:rotate(450deg);
 }
}
</style>